// Static content for the Bay Quarter Shores Lot 17-L investor-grade portal

export const PROPERTY = {
  name: "Bay Quarter Shores",
  lot: "Lot 17-L",
  acres: "0.91 Acres",
  county: "Northumberland County, Virginia",
  zoning: "R-2 Residential Waterfront",
  hoa: "Bay Quarter Shores HOA",
  taxMap: "Tax Map 11-B(12)-17",
  tagline: "Build Your Virginia Waterfront Lifestyle",
  assessment: "$17,800",
  price: "$16,900",
  previousPrice: "$21,900",
  priceReductionDate: "October 2026",
  priceReductionAmount: "$5,000",
};

export const CTA_LABEL = "Request Due Diligence Package";

export const PRICING = {
  features: [
    "Approximately 0.91 Acres",
    "Bay Quarter Shores HOA Community",
    "R-2 Residential Waterfront Zoning",
    "Seller Due Diligence Package Included",
    "Private Sale (FSBO)",
  ],
  paragraph:
    "Bay Quarter Shores Lot 17-L is now offered at $16,900 as part of an October 2026 price reduction. The property includes approximately 0.91 wooded acres within the Bay Quarter Shores waterfront community, together with an extensive seller-prepared due diligence package.",
  assessmentNote: "Current Northumberland County assessment: $17,800.",
};

export const BUYER_CONFIDENCE = [
  { icon: "FileText", title: "Transparent Documentation", text: "Seller has assembled key property records in advance." },
  { icon: "BadgeDollarSign", title: "Competitive Pricing", text: "Priced after reviewing comparable land sales in the local market." },
  { icon: "ShieldCheck", title: "Verified Property Information", text: "County correspondence, HOA documentation, and historical records available." },
  { icon: "Search", title: "Independent Buyer Review Encouraged", text: "Buyers are encouraged to conduct their own inspections and due diligence." },
];

// Uploaded HOA photographs
const UP = {
  clubhouse: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/wyh7y9t1_Clubhouse%20Aerial.jpg",
  clubhouseFront: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/ehch9vq9_Clubhouse%20Front.jpg",
  campEntrance: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/fmr61cs2_Campground%20Entrance.jpg",
  campAerial: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/wyu32357_Campground%20Aerial.jpg",
  boatRamp: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/d6r0m7qr_Boat%20Ramp.jpg",
  basketball: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/dzbqnabx_BasketBall%20Court.jpg",
  beach: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/vbp51a4o_Sandy%20Beach.jpg",
  hunting: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/zrbp1wrq_Hunting%20Area.jpg",
  golf: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/srl3uadm_Golf%20Driving%20Range.jpg",
  locationMap: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/265lewrc_Community%20location%20map%20showing%20Bay%20Quarter%20Shores.png",
  dock: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/mp0b8nsn_Short%20term%20Boat%20Dock.jpg",
  tennis: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/sz8s5d34_Tennis%20Courts.jpg",
  pool: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/6yj7mglq_Swimming%20Pool.jpg",
  clubhouseAerialFeatured: "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/m71nng9d_Clubhouse%20Aerial.jpg",
};

// Full-width banner for the Community Amenities section (uploaded Clubhouse Aerial)
export const COMMUNITY_BANNER = "https://customer-assets.emergentagent.com/job_bay-quarter-lands/artifacts/m71nng9d_Clubhouse%20Aerial.jpg";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1425913397330-cf8af2ff40a1?auto=format&fit=crop&w=2400&q=80",
  aerial: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1600&q=80",
};

export const RIBBON = [
  { label: "Acreage", value: "0.91 Acres" },
  { label: "County", value: "Northumberland" },
  { label: "Zoning", value: "R-2 Residential Waterfront" },
  { label: "Community", value: "Bay Quarter Shores HOA" },
  { label: "Tax Map", value: "11-B(12)-17" },
  { label: "County Assessment", value: "$17,800" },
];

export const AT_A_GLANCE = [
  { label: "Property", value: "Bay Quarter Shores – Lot 17-L", icon: "MapPin" },
  { label: "Size", value: "0.91 Acres", icon: "Ruler" },
  { label: "Zoning", value: "R-2 Residential Waterfront", icon: "ScrollText" },
  { label: "County", value: "Northumberland County, Virginia", icon: "Landmark" },
  { label: "Community", value: "Bay Quarter Shores HOA", icon: "Waves" },
  { label: "Annual HOA Dues", value: "$350 per year", icon: "Wallet" },
  { label: "Utilities", value: "Septic approval required", icon: "Droplets" },
  { label: "Due Diligence", value: "Complete Due Diligence Package Available", icon: "FolderCheck" },
  { label: "Asking Price", value: "$16,900", icon: "Tag" },
];

export const ABOUT_POINTS = [
  "A quiet wooded homesite of approximately 0.91 acres, offering privacy and a natural setting.",
  "Located within the established Bay Quarter Shores waterfront community in Virginia's Northern Neck.",
  "Suitable for a future custom residence, subject to applicable County and HOA approvals.",
  "Ownership includes access to the private beach, swimming pool, clubhouse, campground, boat ramp, tennis courts, hunting area, golf driving range, basketball court, and additional community amenities.",
  "The buyer is responsible for final development approvals and independent due diligence.",
];

export const COMMUNITY_INTRO =
  "Only 15 minutes from an ACE Hardware and approximately 10 minutes from a large grocery store, Bay Quarter Shores offers a wide range of amenities available exclusively to members.";

export const AMENITIES = [
  { title: "Sandy Beach", icon: "Waves", img: UP.beach, desc: "For members and their guests only." },
  { title: "Campground", icon: "Tent", img: UP.campAerial, desc: "Available to members and offers short-term camping with bath house and utility access. Daily, weekly, and full-season camping are available between April 1 and December 31." },
  { title: "Boat Ramp", icon: "Sailboat", img: UP.boatRamp, desc: "Available year-round for use by all members." },
  { title: "Swimming Pool", icon: "Droplets", img: UP.pool, desc: "Available to members and their guests from Memorial Day through Labor Day." },
  { title: "Hunting Area", icon: "Crosshair", img: UP.hunting, desc: "Available to members by permit only." },
  { title: "Short-Term Community Boat Dock", icon: "Anchor", img: UP.dock, desc: "Community dock available for short-term use by smaller boats." },
  { title: "Tennis Courts", icon: "CircleDot", img: UP.tennis, desc: "Two tennis courts available for members." },
  { title: "Large Clubhouse with High-Speed Wi-Fi", icon: "Home", img: UP.clubhouseFront, desc: "A spacious clubhouse featuring a full kitchen for meetings and gatherings. High-speed Wi-Fi is available throughout the clubhouse. The clubhouse is not available for reservations from Memorial Day through Labor Day. Hours are 8:00 AM to 9:00 PM, with doors automatically locking after hours." },
  { title: "Basketball Court", icon: "Dribbble", img: UP.basketball, desc: "Outdoor basketball court available for members." },
  { title: "Golf Driving Range", icon: "Flag", img: UP.golf, desc: "Long driving range available for members to practice throughout the year." },
];

export const PROPERTY_STORY = [
  { year: "1990", text: "Conventional septic application denied." },
  { year: "2023", text: "Property acquired by current owner." },
  { year: "2026", text: "County correspondence confirms parcel is considered buildable, subject to applicable approvals." },
  { year: "2026", text: "Comprehensive seller due diligence completed and property prepared for sale." },
];

export const DUE_DILIGENCE = [
  "Special Commissioner's Deed",
  "Property Record Card",
  "Building & Zoning Correspondence",
  "HOA Information",
  "Health Department Records",
];

export const DISCLOSURE = [
  "Historical records indicate a conventional septic system application was denied in 1990.",
  "Northumberland County Building & Zoning has indicated the parcel is considered buildable, subject to septic approval and applicable development requirements.",
  "County correspondence also indicates that an alternative septic system may be appropriate.",
  "No guarantees regarding future septic approval or development are made.",
  "Prospective buyers should perform their own independent due diligence.",
];

export const GALLERY = [
  { title: "Community Entrance", category: "Community Entrance", url: UP.campEntrance },
  { title: "Sandy Beach", category: "Sandy Beach", url: UP.beach },
  { title: "Campground — Aerial", category: "Campground", url: UP.campAerial },
  { title: "Campground — Entrance", category: "Campground", url: UP.campEntrance },
  { title: "Boat Ramp", category: "Boat Ramp", url: UP.boatRamp },
  { title: "Swimming Pool", category: "Swimming Pool", url: UP.clubhouse },
  { title: "Hunting Area", category: "Hunting Area", url: UP.hunting },
  { title: "Short-Term Boat Dock", category: "Short-Term Boat Dock", url: UP.dock },
  { title: "Tennis Courts", category: "Tennis Courts", url: UP.tennis },
  { title: "Clubhouse", category: "Clubhouse", url: UP.clubhouseFront },
  { title: "Basketball Court", category: "Basketball Court", url: UP.basketball },
  { title: "Golf Driving Range", category: "Golf Driving Range", url: UP.golf },
];

export const GALLERY_CATEGORIES = [
  "All",
  "Community Entrance",
  "Sandy Beach",
  "Campground",
  "Boat Ramp",
  "Swimming Pool",
  "Hunting Area",
  "Short-Term Boat Dock",
  "Tennis Courts",
  "Clubhouse",
  "Basketball Court",
  "Golf Driving Range",
];

export const MAP_POINTS = [
  { label: "Lot", top: "44%", left: "50%", primary: true },
  { label: "Entrance", top: "22%", left: "26%" },
  { label: "Clubhouse", top: "32%", left: "62%" },
  { label: "Pool", top: "40%", left: "70%" },
  { label: "Marina", top: "64%", left: "34%" },
  { label: "Boat Ramp", top: "72%", left: "48%" },
  { label: "Beach", top: "78%", left: "64%" },
  { label: "Nearby Heathsville", top: "16%", left: "72%" },
];

export const COMMUNITY_LOCATION_DESC =
  "Bay Quarter Shores is a private waterfront community located in Virginia's Northern Neck, offering convenient access to the Chesapeake Bay while remaining close to everyday conveniences, including grocery stores, hardware stores, marinas, and nearby towns.";

// Set to an uploaded map URL when available to replace the placeholder.
export const COMMUNITY_LOCATION_MAP = UP.locationMap;

export const BUYER_ROADMAP = [
  { step: "1", title: "Review Property Information", text: "Explore the property overview, photos, documents, and disclosures." },
  { step: "2", title: "Request Due Diligence Package", text: "Receive the complete due diligence package for your independent review." },
  { step: "3", title: "Complete Independent Due Diligence", text: "Conduct any inspections, survey work, septic evaluation, or development review you consider appropriate." },
  { step: "4", title: "Submit an Offer", text: "Present your offer with confidence after completing your review." },
  { step: "5", title: "Close Through a Virginia Title Company", text: "Complete the purchase through a licensed Virginia title company." },
];

export const FAQS = [
  { q: "Why are you selling?", a: "The property was acquired and prepared for a transparent resale. The seller has assembled a comprehensive due diligence package to help the right buyer move forward with confidence." },
  { q: "Has the property been evaluated for septic?", a: "Historical Environmental Health and septic records have been obtained. A conventional septic application was denied in 1990. The buyer is responsible for performing a current septic evaluation during their due diligence." },
  { q: "What happened in 1990?", a: "Historical records indicate a conventional septic system application was denied in 1990. County correspondence indicates the parcel is considered buildable subject to septic approval, and that an alternative septic system may be appropriate." },
  { q: "Does the HOA allow rentals?", a: "Rental policies are governed by the HOA regulations, which are included in the due diligence package. Buyers should review the current covenants and restrictions directly." },
  { q: "What documents are available?", a: "The due diligence package includes the Special Commissioner's Deed, property record card, building & zoning correspondence, HOA information, and Health Department records, among other supporting documentation." },
  { q: "Can I visit the property?", a: "Yes. You may schedule a property conversation and arrange a visit through the contact form." },
  { q: "Can I walk the lot?", a: "Yes. Prospective buyers are encouraged to walk the lot as part of their evaluation." },
  { q: "How do I obtain the Due Diligence Package?", a: "Complete the request form on this site. Upon submission, you will receive a secure link to the documentation." },
  { q: "Who performs the septic evaluation?", a: "The buyer is responsible for commissioning a current septic evaluation with a licensed professional during the due diligence period." },
  { q: "What utilities serve the area?", a: "Utility availability should be independently verified with the applicable providers and the County. A septic system approval is required for development." },
  { q: "How are HOA amenities accessed?", a: "Amenity access is provided to members in good standing through the Bay Quarter Shores HOA, subject to its regulations and annual dues of $350." },
  { q: "How much are the annual HOA dues?", a: "Annual HOA dues are currently $350 per year, providing access to Bay Quarter Shores' private amenities, including the beach, swimming pool, clubhouse, campground, boat ramp, tennis courts, basketball court, golf driving range, and more." },
  { q: "Can I build immediately?", a: "Development of the property remains subject to Northumberland County requirements, HOA guidelines, and Environmental Health approval for an appropriate septic system. Buyers are encouraged to perform their own independent due diligence before purchasing." },
];

export const NAV_LINKS = [
  { label: "Overview", href: "#overview" },
  { label: "Property", href: "#property" },
  { label: "Community", href: "#community" },
  { label: "Due Diligence", href: "#due-diligence" },
  { label: "Location", href: "#location" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];
